// types/index.ts
export enum LocalCurrency {
    naira = '₦',
    shortcode = 'NGN'
}

export enum Country {
    nigeria = 'Nigeria'
}

export interface DataProduct {
    id: number;
    name: string;
    sku: string;
    status: string;
    description: string;
    category: Category;
    createdAt: string;
    productImages: ProductImages[];
    inventories: Inventories[];
    variations: Variations[];
}

export interface Product extends DataProduct {
    currency: LocalCurrency;
    image: string;
    price: number;
    basePrice: number;
    discountPrice: number;
    applyDiscount: boolean;
    qtyInStock: number;
    discountType: string;
    strikeThroughPriceString?: string;
    discountOff?: string;
    priceString?: string;
    pouchesInCarton?: number;
    productWeight?: number;
    unit?: string;
}

export interface Variations {}

export interface Category {
    id: number;
    name: string;
    avatarBase64: string;
    status: string;
    description: string;
    createdAt: string;
}

export interface ProductImages {
    featured: boolean;
    fileType: string;
    image: string;
}

export interface Inventories {
    totalQuantity: number;
    allowBackOrder: boolean;
    applyDiscount: boolean;
    basePrice: number;
    discountPrice: number;
    discountType: string;
    qtyInStock: number;
    store: Store;
}

export interface Store {
    id: number;
    name: string;
    address: string;
    phone: string;
    logo: string;
    status: string;
    logisticCompany: LogisticCompany;
    latitude: number;
    longitude: number;
}

export interface LogisticCompany {
    id: number;
    name: string;
    address: string;
    baseShippingCharges: number;
    phone: string;
    status: string;
    logo: string;
}
  
export interface BannerItem {
    id: number;
    image: string;
    title: string;
    description: string;
    link: string;
}

export interface Testimonial {
    id: number;
    quote: string;
    author: string;
}

export interface BlogPost {
    id: number;
    title: string;
    excerpt: string;
    image: string;
    category: string;
    date: string;
}

export interface FeatureItem {
    icon: string;
    title: string;
    description: string;
}

export interface InstagramPost {
    id: number;
    image: string;
    link: string;
}

export interface FooterLink {
    title: string;
    href: string;
}
  
export interface FooterSection {
    title: string;
    links: FooterLink[];
}

export interface Configurations {
    key: string;
    amount: number;
    email: string;
    currency?: LocalCurrency;
    firstName?: string;
    lastName?: string;
    phone?: string;
    reference?: string;
}

export type PaystackErrorType = {
    type: "setup"; 
    message: string;
}

export type PaystackTransaction = {
    id: string;
    reference: string;
    message: string;
    redirecturl: string;
    status: string;
    trans: string;
    transaction: string;
    trxref: string;
}

export type ProductPricingModel = {
    price: number;
    priceString: string;
    strikeThroughPrice?: number;
    strikeThroughPriceString?: string;
    discountOff?: string;
}

export interface Orders {
    id: number;
    orderNumber: string;
    shippingMethod: string;
    status: string;
    totalPrice: number;
    deliveryDate: string;
    createdAt: string;
    orderItems: OrderItem[];
    payment: PaymentDTO;
    shipping: Shipping;
    store: Store;
    // orderHistories: any[];
}

export interface OrderHistories {
    id: number;
    comment: string;
    status: string;
    createdAt: string;
}

export interface OrderItem {
    id: number;
    discountOff: string;
    discountPrice: number;
    isDiscounted: boolean;
    currency: string;
    product: DataProduct;
    price: number;
    quantity: number;
    totalPrice: number;
}

export interface OrderPayload {
    totalPrice: number;
    storeId: number;
    shippingId: number;
    totalQuantity: number;
    currency: string;
    orderItems: OrderItemPayload[];
    shippingAddress: iDeliveryLocation;
}

export interface OrderItemPayload {
    productId: number;
    discountedPrice: number;
    discountedPriceString: string;
    currency: string;
    discountOff: string;
    quantity: number;
    basePrice: number;
}

export interface iDeliveryLocation {
    id?: number;
    firstName?: string;
    lastName?: string;
    address?: string;
    country?: string;
    state?: string;
    email?: string;
    phone?: string;
    heading?: string;
    latitude?: number;
    longitude?: number;
    defaults?: boolean;
    userId?: number;
}

export interface CustomerKyc {
    id: number;
    firstName: string;
    lastName: string;
    address: string;
    country: string;
    state: string;
    email: string;
    phone: string;
    city: string;
    postalCode: string;
    password: string;
    confirmPassword: string;
}

export interface HttpResponse {
    status: number,
    data: any[] | any,
    message: string | any,
    isCanceled: boolean
}

export interface BrowserInfo {
    ip: string;
    browser: string;
    os: string;
    userAgent: string;
    acceptLanguage: string;
}

export interface OrderCreated {
    orderDto: OrderDTO;
    paymentDto: PaymentDTO;
    shippingPaymentDto: PaymentDTO;
    totalAmountToBePaid: number;
}

export interface OrderDTO {
    [key: string]: any;
}

export interface PaymentDTO {
    amount: number;
    currency: string;
    description: string;
    isRefunded: boolean;
    paymentChannel: string;
    paymentRef: string;
    paymentResponse: string;
    paymentStatus: string;
    relatedEntity: string;
    relatedId: number;
    totalAmount: number;
    transactionStatus: string;
    txRef: string;
    type: string;
}

export interface SignupCredentials {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    password: string;
}

export interface Credentials {
    email: string;
    password: string;
}

export interface Shipping {
    id: number;
    billingAddress: iDeliveryLocation;
    isPaid: boolean;
    isShippingSameAsBilling: boolean;
    logisticCompany: LogisticCompany;
    payment: PaymentDTO;
    shippingAddress: iDeliveryLocation;
    shippingCost: number;
    shippingNumber: string;
    shippingRate: string;
    status: string;
}